<template>
    <div>
        <div class="container">
            <button class="button is-primary is-pulled-right"
                    v-if="catalogRequests.length !== 0"
                    @click="printAll()">
                Print All
            </button>
            <data-table :data-set="catalogRequests" :page-length="50" :columns="[
            {name: 'Contact', prop: ['first_name', 'last_name', 'email', 'phone'], type: 'text'},
            {name: 'Address', prop: ['line1', 'line2', 'line3', 'city', 'state', 'zip', 'country'], type: 'text'},
            {name: 'Referrer', prop: 'referrer', type: 'text'},
            {name: 'Status', prop: 'printed', type: 'number', searchable: false},
            {name: 'Created', prop: 'created_at', type: 'date', filter: ['moment', ['from', 'now']]},
        ]">
                <template slot="column_Contact" slot-scope="props">
                    {{ props.row.first_name }} {{ props.row.last_name }}
                    <br/>
                    {{ props.row.email }}
                    <br v-if="props.row.phone"/>
                    {{ props.row.phone | phone }}
                </template>
                <template slot="column_Address" slot-scope="props">
                    {{ props.row.line1 }}
                    <br v-if="props.row.line2">
                    {{ props.row.line2 }}
                    <br v-if="props.row.line3">
                    {{ props.row.line3 }}
                    <br/>
                    {{ props.row.city }}, {{ props.row.state }} {{ props.row.zip }} {{ props.row.country }}
                </template>
                <template slot="column_Status" slot-scope="props">
                    {{ props.row.referrer }}
                </template>
                <template slot="column_Status" slot-scope="props">
                    {{ props.row.printed ? 'Printed' : 'Not Printed' }}
                </template>
            </data-table>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex"
    export default {
        data() {
            return {}
        },
        computed: mapGetters(['catalogRequests']),
        methods: {
            printAll() {
                let contents = this.catalogRequests.filter(request => request.printed !== true);
                this.$bus.$emit('startPrint', {
                    type: 'request',
                    contents,
                })
            },
        }
    };
</script>



// WEBPACK FOOTER //
// Requests.vue?47e768de